import { toastSweetAlert } from '../Components/Helpers/ToastSweetAlert'

let toastId // Variable para almacenar el identificador del mensaje

export function waitForServerViaWS() {
  // Verificamos si el mensaje ya fue mostrado
  if (!toastId) {
    // Mostrar mensaje inicial de reconexión
    toastId = toastSweetAlert({
      mode: 'loading',
      title: 'Trabajando para reconectar...',
      message:
        'No pudimos conectar con el servidor en este momento. No te preocupes, estamos trabajando para restablecer la conexión automáticamente. Puedes esperar un momento o, si prefieres, intentalo más tarde.',
      icon: 'error',
      showCloseButton: false,
      showConfirmButton: false,
    })
  }

  const socket = new WebSocket(process.env.REACT_APP_GRAPH_WS_SERVER)

  socket.onopen = () => {
    // Si ya está conectado, cambiamos el mensaje.
    toastSweetAlert({
      mode: 'ok',
      title: 'Conexión establecida',
      message: '¡Conexión restaurada, recargando la página!',
      icon: 'success',
      showCloseButton: false,
      showConfirmButton: false,
    })

    // Esperar 1 segundo antes de recargar
    setTimeout(() => {
      window.location.reload() // Recargar la página al restablecer la conexión
    }, 1000)
  }

  socket.onerror = (error) => {
    // Si el error es 502, intentamos reconectar
    if (error.message.includes('502')) {
      console.log('Error 502 detectado, reintentando conexión...')
      setTimeout(waitForServerViaWS, 5000) // Reintentar después de 5 segundos
    } else {
      // Para otros errores, podemos tratar con un reintento general
      setTimeout(waitForServerViaWS, 5000) // Reintentar después de 5 segundos
    }
  }
}
